export const ACTION_STRING = {
  authLogin: "AUTH_LOGIN",
  authLogout: "AUTH_LOGOUT",
  register: "REGISTER",
  dataProfile: 'GET_PROFILE',
  editProfile: "EDIT_PROFILE",
  authReset: "AUTH_RESET",
  pending: "_PENDING",
  fulfilled: "_FULFILLED",
  rejected: "_REJECTED",
  getProducts: "GET_PRODUCTS",
  createProduct: "CREATE_PRODUCT",
  updateProducts: "UPDATE_PRODUCT",
  getDetailProduct: "GET_PRODUCT_DETAIL",
  getProfile: "GET_PROFILE",
  updateProfile: "UPDATE_PROFILE",
  getPromos: "GET_PROMOS",
  counterUp: "COUNTER_UP",
  counterDown: "COUNTER_DOWN",
  counterReset: "COUNTER_RESET",
  addCart: "ADD_CART",
  deleteCart: "ADD_CART",
  getCategories: "GET_CATEGORIES",
};